import React from 'react';
import Lottie from 'react-lottie';

export default function LottieAnimator({ ...props }) {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: props.animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Lottie options={defaultOptions} style={{ maxWidth: '90%', margin: '0' }} />
  );
}
